import styled from "styled-components";

export const SubscriptionWrapper = styled.div`
  padding: 25px 25px 100px 25px;
  .planDataContainer {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 530px;
    border: 1px solid var(--borderLight);
    border-radius: 10px;
    padding: 20px 24px 20px 24px;
    flex-direction: column;
    box-shadow: 0 20px 27px -10px rgba(6, 74, 147, 0.1);
    .headToTxt {
      min-height: 180px;
    }
    .descBox {
      min-height: 60px;
      padding-bottom: 10px;
    }
    .subsPriceCurrency {
      display: flex;
      align-items: flex-end;
      gap: 7px;
      .subsPrice {
        font-family: var(--regularBold);
        line-height: 30px;
      }
      .subsCurrency {
        font-family: var(--medium);
        body.rtl & {
          font-family: var(--arBoldSans);
          line-height: 30px;
        }
      }
    }
  }
  .planDataContainerBlue {
    border: 2px solid var(--themeColor);
  }
  .planDataContainerGreen {
    border: 2px solid var(--themeColor2);
  }
  body.rtl & {
    button span {
      font-family: var(--arBoldSans);
    }
  }
  @media (max-width: 1299px) {
    .planDataContainer {
      padding: 20px 12px 20px 12px;
    }
  }
`;
export const SettingsWrapper = styled.div`
  .content-container-topBar {
    display: flex;
    width: 100%;
    gap: 16px;
    & > div {
      width: 100%;
      background-color: var(--white);
      border-radius: 6px;
      padding-left: 16px;
      padding-right: 16px;
      display: flex;
      align-items: center;
      height: 40px;
    }
    .radioFilterContainer {
      gap: 10px;

      label {
        padding: 8px 0;
        gap: 10px;
      }
    }
    .rangepickerContainer {
      gap: 40px;
    }
  }
  .fileAttachmentBox {
    display: flex;
    width: fit-content;
    background-color: var(--bgSecondary);
    align-items: center;
    border-radius: 10px;
    padding: 10px 16px;
    gap: 20px;
    max-height: 120px;
    span {
      padding-top: 2px;
    }
  }
  .billing-icon-wrapper {
    padding: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    background-color: var(--lightGrayBg);
  }
  .uploadImgContainer {
    width: 290px;
    .defaultUploadBox {
      height: 75px;
    }
  }
  @media (max-width: 1300px) {
    .content-container-topBar {
      .rangepickerContainer {
        gap: 10px;
      }
    }
  }
  @media (max-width: 1250px) {
    .content-container-topBar {
      flex-wrap: wrap;
      & > div {
        width: auto;
      }
      .rangepickerContainer {
        gap: 10px;
      }
    }
  }
  @media (max-width: 991px) {
    .content-container-topBar {
      & > div {
        width: 100%;
      }
    }
  }
  @media (max-width: 767px) {
    .content-container-topBar {
      .rangepickerContainer {
        flex-wrap: wrap;
        height: auto;
        padding-top: 8px;
        padding-bottom: 8px;
      }
    }
  }
`;
export const FormDataContainer = styled.div`
  .img-box {
    position: relative;
    .icon-box {
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 43px;
        height: 43px;
        img {
          height: auto;
          object-fit: contain;
        }
      }
    }
    img {
      border-radius: 16px;
      width: 220px;
      height: 101px;
      /* width: 100%;
            height: 100%; */
      object-fit: cover;
    }
  }
`;
